export enum OrderIntentEnum {
  ADD_ITEM = 'addItem',
  REMOVE_ITEM = 'removeItem',
  MODIFY_ITEM = 'modifyItem',
  REMOVE_ALL_ITEMS = 'removeAllItems',
  RESTORE_PREVIOUS_ORDER = 'restorePreviousOrder',
  MESSAGE = 'message',
  ERROR = 'error',
  IGNORE = 'ignore'
}